import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { delete_image, fetch_images, reorder_image, upload_image } from './api';
import type { CatalogImageOwnerType } from './types';

const key = (owner_type: CatalogImageOwnerType, owner_id: string) =>
  ['catalog-images', owner_type, owner_id] as const;

export function use_catalog_images(owner_type: CatalogImageOwnerType, owner_id: string | undefined) {
  return useQuery({
    queryKey: key(owner_type, owner_id ?? ''),
    queryFn: () => fetch_images(owner_type, owner_id as string),
    enabled: !!owner_id,
  });
}

export function use_upload_image(owner_type: CatalogImageOwnerType, owner_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => upload_image(owner_type, owner_id, file),
    onSuccess: () => qc.invalidateQueries({ queryKey: key(owner_type, owner_id) }),
  });
}

export function use_delete_image(owner_type: CatalogImageOwnerType, owner_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_image(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: key(owner_type, owner_id) }),
  });
}

export function use_reorder_image(owner_type: CatalogImageOwnerType, owner_id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, display_order }: { id: string; display_order: number }) => reorder_image(id, display_order),
    onSuccess: () => qc.invalidateQueries({ queryKey: key(owner_type, owner_id) }),
  });
}
